<ngx-spinner
  [fullScreen]="true"
  bdColor="rgba(0, 0, 0, 0.8)"
  color="#fff"
  size="medium"
  type="ball-pulse"
><p style="color: white">Loading...</p></ngx-spinner
>
<router-outlet></router-outlet>
